import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bfdaac8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  key: 0,
  class: "dropdown-footer"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2
};
import { defineComponent } from 'vue';
import debounce from 'lodash/debounce';
import { message } from 'ant-design-vue';
import { OK } from '@/common';
import { searchSimpleUsers } from '@/api/lawyerBoard';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddAccountModal',
  props: {
    open: {
      type: Boolean
    },
    existedIds: null
  },
  emits: ["update:open", "submit"],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    /** 下拉分页每页条数，与后端建议的 50～100 对齐 */
    const PAGE_SIZE = 50;
    /** 搜索防抖间隔：打字停顿超过这个时长才真正发请求 */
    const SEARCH_DEBOUNCE_MS = 500;
    /** dropdownRender 的插槽 VNode 透传，用于在原菜单下方追加加载状态行 */
    const VNodes = defineComponent({
      props: {
        vnodes: {
          type: Object,
          required: true
        }
      },
      render() {
        return this.vnodes;
      }
    });
    const selectedUserId = ref();
    const keyword = ref('');
    const searching = ref(false);
    const loadingMore = ref(false);
    const submitting = ref(false);
    const errorText = ref('');
    const options = ref([]);
    /** 已加载页码与总数，用于判断是否还有下一页 */
    const page = ref(1);
    const total = ref(0);
    /** 当前 options 对应的关键字；null 表示尚未加载或上次加载失败，用于跳过重复查询 */
    const loadedKeyword = ref(null);
    const hasMore = computed(() => options.value.length < total.value);
    /** 请求序号：只接受最后一次请求的结果，避免慢请求覆盖快请求 */
    let requestSeq = 0;
    /**
     * 拉取用户下拉数据。
     * @param key 关键字
     * @param targetPage 目标页码
     * @param append true=滚动加载下一页并追加，false=新查询并整体替换
     *
     * 追加与替换共用同一个 requestSeq：新查询会让在途的翻页请求作废，
     * 避免旧关键字的第 2 页被追加到新关键字的结果里。
     */
    const fetchUsers = async (key, targetPage = 1, append = false) => {
      const seq = requestSeq += 1;
      if (append) {
        loadingMore.value = true;
      } else {
        searching.value = true;
      }
      try {
        const res = await searchSimpleUsers({
          keyword: key,
          pageIndex: targetPage,
          pageSize: PAGE_SIZE
        });
        if (seq !== requestSeq) return;
        if (res && res.code === OK) {
          const mapped = res.data.list.map(item => ({
            label: `${item.userName}(${item.userId})`,
            value: item.userId,
            user: item
          }));
          options.value = append ? [...options.value, ...mapped] : mapped;
          total.value = res.data.total;
          page.value = targetPage;
          loadedKeyword.value = key;
        }
      } catch (error) {
        if (seq !== requestSeq) return;
        // 查询失败保留弹窗与已输入关键字，仅提示错误；翻页失败时保留已加载的前几页
        if (!append) {
          options.value = [];
          total.value = 0;
          page.value = 1;
          // 置空以便下次同一关键字能重新查询，不被去重挡掉
          loadedKeyword.value = null;
        }
        errorText.value = '用户查询失败，请重试';
        message.error('用户查询失败，请重试');
      } finally {
        if (seq === requestSeq) {
          searching.value = false;
          loadingMore.value = false;
        }
      }
    };
    /**
     * 首页查询入口：关键字与当前已加载结果相同时直接跳过，不重复打请求。
     * 打字防抖、下拉展开、清空重查都走这里，保证去重口径一致。
     */
    const loadFirstPage = key => {
      if (loadedKeyword.value === key) return;
      fetchUsers(key, 1, false);
    };
    const debouncedFetch = debounce(key => loadFirstPage(key), SEARCH_DEBOUNCE_MS);
    /** 下拉滚动到底部时加载下一页 */
    const handlePopupScroll = e => {
      const el = e.target;
      if (!el) return;
      // 距底部 20px 内触发；搜索中 / 翻页中 / 已加载完则忽略
      const reachedBottom = el.scrollTop + el.offsetHeight >= el.scrollHeight - 20;
      if (!reachedBottom || searching.value || loadingMore.value || !hasMore.value) return;
      fetchUsers(keyword.value, page.value + 1, true);
    };
    const handleSearch = value => {
      keyword.value = value;
      errorText.value = '';
      debouncedFetch(value);
    };
    const handleDropdownVisibleChange = visible => {
      if (visible) {
        // 展开时若已有同关键字结果则直接复用；不取消在途防抖，避免刚敲的字被丢掉
        loadFirstPage(keyword.value);
      }
    };
    const handleChange = () => {
      errorText.value = '';
    };
    const resetState = () => {
      debouncedFetch.cancel();
      requestSeq += 1;
      selectedUserId.value = undefined;
      keyword.value = '';
      options.value = [];
      page.value = 1;
      total.value = 0;
      loadedKeyword.value = null;
      errorText.value = '';
      searching.value = false;
      loadingMore.value = false;
      submitting.value = false;
    };
    const handleCancel = () => {
      resetState();
      emit('update:open', false);
    };
    const handleOk = () => {
      var _options$value$find;
      if (!selectedUserId.value) {
        errorText.value = '请选择账号名称';
        message.warning('请选择账号名称');
        return;
      }
      if (props.existedIds.includes(selectedUserId.value)) {
        errorText.value = '该账号已添加';
        message.warning('该账号已添加');
        return;
      }
      // 展示名 / 登录名随下拉结果一并提交，后端不再回查用户中心
      const picked = (_options$value$find = options.value.find(item => item.value === selectedUserId.value)) === null || _options$value$find === void 0 ? void 0 : _options$value$find.user;
      emit('submit', {
        ssoUserId: selectedUserId.value,
        displayName: (picked === null || picked === void 0 ? void 0 : picked.userName) || '',
        userName: (picked === null || picked === void 0 ? void 0 : picked.loginName) || ''
      });
    };
    /** 由父级在提交成功后调用，关闭弹窗并清空表单 */
    const close = () => {
      resetState();
      emit('update:open', false);
    };
    const setSubmitting = value => {
      submitting.value = value;
    };
    expose({
      close,
      setSubmitting
    });
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        title: "新增账号",
        "confirm-loading": submitting.value,
        "ok-text": "确定",
        "cancel-text": "取消",
        "mask-closable": false,
        onOk: handleOk,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          "label-col": {
            style: {
              width: '84px'
            }
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "账号名称",
            required: "",
            "validate-status": errorText.value ? 'error' : '',
            help: errorText.value || undefined
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: selectedUserId.value,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => selectedUserId.value = $event),
              "show-search": "",
              "allow-clear": "",
              placeholder: "请选择账号名称",
              "filter-option": false,
              options: options.value,
              loading: searching.value,
              onSearch: handleSearch,
              onDropdownVisibleChange: handleDropdownVisibleChange,
              onPopupScroll: handlePopupScroll,
              onChange: handleChange
            }, {
              notFoundContent: _withCtx(() => [searching.value ? (_openBlock(), _createBlock(_component_a_spin, {
                key: 0,
                size: "small"
              })) : (_openBlock(), _createElementBlock("span", _hoisted_1, "暂无匹配用户"))]),
              dropdownRender: _withCtx(({
                menuNode: menu
              }) => [_createVNode(_unref(VNodes), {
                vnodes: menu
              }, null, 8, ["vnodes"]), options.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [loadingMore.value ? (_openBlock(), _createBlock(_component_a_spin, {
                key: 0,
                size: "small"
              })) : _unref(hasMore) ? (_openBlock(), _createElementBlock("span", _hoisted_3, "下拉加载更多")) : (_openBlock(), _createElementBlock("span", _hoisted_4, "已加载全部 " + _toDisplayString(total.value) + " 条", 1))])) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["value", "options", "loading"])]),
            _: 1
          }, 8, ["validate-status", "help"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});